module.exports = __webpack_public_path__ + "static/media/mps_gain_m.57c2ca11.webp";